function handleRemoveUpgradedShipping(event) {
    event.preventDefault(); // Prevent the default link behavior

    var removeUrl = event.currentTarget.href; // Get the URL from the link

    fetch(removeUrl, {
      method: 'POST', // Use POST method to remove the item from the cart
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        // Redirect to the cart page after successful removal
        window.location.href = '/cart';
      } else {
        console.error('Failed to remove item from cart');
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }